import React from "react";
import LoginPanelContent from "./routes/LoginPanelContent";
import AuthPanel from "./routes/components/AuthPanel";
import { homepage, needHelp } from "./routes/components/links";
import { useLoaderData } from "react-router";

const LoginApp = () => {
  const viewModel = useLoaderData<server.viewmodel.AccountSignInFrontModel>();
  const [error, setError] = React.useState<string>(viewModel.error);
  const [errorDescription, setErrorDescription] = React.useState<string>(viewModel.errorDescription);
  const [isLoggingIn, setIsLoggingIn] = React.useState<boolean>(false);

  const applicationKey = React.useRef<string>(null);

  // The Excel addins use this to include their application key
  React.useEffect(() => {
    const onMessageReceived = (event: MessageEvent) => {
      if (event.data?.type === "setApplicationKey") {
        applicationKey.current = event.data.applicationKey;
      }
    }

    window.addEventListener("message", onMessageReceived)

    return () => {
      window.removeEventListener("message", onMessageReceived);
    }

  }, []);

  const onLoginClick = async (ev: React.FormEvent<HTMLFormElement>, username: string, password: string) => {
    ev.preventDefault();

    setIsLoggingIn(true);
    try {
      const { data: loginOutcome } = await window.CoreApi.Authentication.SignInWithCredentials({
        username,
        password,
        applicationKey: applicationKey.current
      });

      if (loginOutcome.hasErrors) {
        setError(loginOutcome.errors.map(e => e.message).join("\n"));
        setErrorDescription("");
        setIsLoggingIn(false);
      } else {
        window.parent?.postMessage?.("loggedIn", "*"); // Any external SystemOne UIs can listen for this event to know when the user has logged in
        window.location.href = viewModel.returnUrl;
      }
    } catch {
      setError(RESX.GeneralLabels.SomethingUnexpectedHappened);
      setErrorDescription("");
      setIsLoggingIn(false);
    }
  };

  return <AuthPanel additionalFooterContent={<>{homepage}|{needHelp}</>}>
    <LoginPanelContent
      onLogin={onLoginClick}
      returnUrl={viewModel.returnUrl}
      errorMessage={error}
      errorDescription={errorDescription}
      isLoggingIn={isLoggingIn}
      browser={site.browser}
    />
  </AuthPanel>;
};

export default LoginApp;